import { useState, useEffect } from 'react'
import './Navigation.css'

export default function Navigation({ onBookCall }) {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'About',    href: '#about'    },
    { label: 'Contact',  href: '#contact'  },
  ]

  const handleNav = (href) => {
    setMenuOpen(false)
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="nav__inner container">
        {/* Logo */}
        <a className="nav__logo" href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }) }}>
          <LogoMark />
          <span className="nav__wordmark">NorthCortex</span>
        </a>

        {/* Desktop links */}
        <nav className="nav__links" aria-label="Main navigation">
          {navLinks.map(l => (
            <a key={l.href} className="nav__link" href={l.href}
               onClick={(e) => { e.preventDefault(); handleNav(l.href) }}>
              {l.label}
            </a>
          ))}
          <button className="btn btn--primary nav__cta" onClick={onBookCall}>
            Book a Call
          </button>
        </nav>

        {/* Mobile hamburger */}
        <button className={`nav__hamburger${menuOpen ? ' open' : ''}`}
                aria-label="Toggle menu" onClick={() => setMenuOpen(v => !v)}>
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="nav__drawer">
          {navLinks.map(l => (
            <a key={l.href} className="nav__drawer-link" href={l.href}
               onClick={(e) => { e.preventDefault(); handleNav(l.href) }}>
              {l.label}
            </a>
          ))}
          <button className="btn btn--primary nav__drawer-cta" onClick={() => { setMenuOpen(false); onBookCall() }}>
            Book a Discovery Call
          </button>
        </div>
      )}
    </header>
  )
}

function LogoMark() {
  return (
    <svg width="36" height="36" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="14" y="14" width="46" height="172" fill="white"/>
      <rect x="140" y="14" width="46" height="172" fill="white"/>
      <line x1="60" y1="42" x2="140" y2="158" stroke="#2E86C1" strokeWidth="6" strokeLinecap="round"/>
      <circle cx="60" cy="42" r="22" fill="#1B4F72"/>
      <circle cx="60" cy="42" r="15" fill="#2E86C1"/>
      <circle cx="100" cy="100" r="22" fill="#1B4F72"/>
      <circle cx="100" cy="100" r="15" fill="#2E86C1"/>
      <circle cx="140" cy="158" r="22" fill="#1B4F72"/>
      <circle cx="140" cy="158" r="15" fill="#2E86C1"/>
    </svg>
  )
}
